import React, { useEffect, lazy, useState, Suspense } from "react";
import Favicon from "react-favicon";
import { RouterProvider } from "react-router-dom";
import ScrollToTop from "react-scroll-to-top";

import "../lib/moment-timezone-with-data-10-year-range";
import router from "../routes/router";
import { useUTMParams } from "shared/hooks/useUTMParams";

// import PushNotificationModal from "modules/PushNotificationModal/PushNotificationModal";

import "../styles/App.scss";
import "../styles/librariesCustomization.scss";
import "shared/assets/fonts/Montserrat/font-face.css";

const Cookies = lazy(() => import("modules/Cookies/Cookies"));

function App() {
  const [showCookies, setShowCookies] = useState(false);

  useUTMParams();

  useEffect(() => {
    const agreeWithCookies = localStorage.getItem("agreeWithCookies");
    if (agreeWithCookies === null || agreeWithCookies === "false") {
      setShowCookies(true);
    }
  }, []);

  return (
    <>
      <Favicon url={"/icon-logo.png"} />
      <Suspense>
        <RouterProvider router={router} />
      </Suspense>
      <ScrollToTop smooth />
      {showCookies && <Cookies />}
      {/* <PushNotificationModal /> */}
    </>
  );
}

export default App;
